import { Society, SocietyValue } from 'types';
import { checkIsPreviousDate } from './checkIsPreviousDate';

export const getSocietyValueAtDate = (society: Society, date: Date): number => {
  const bestMatch = society?.societyValues?.reduce<SocietyValue | null>(
    (latest, current) => {
      const currentDate = new Date(current.date);

      if (checkIsPreviousDate(currentDate, date)) {
        if (
          !latest ||
          checkIsPreviousDate(new Date(latest.date), currentDate)
        ) {
          return current;
        }
      }
      return latest;
    },
    null
  );

  return bestMatch?.value ?? 0;
};

export const getSocietyValue = (society: Society): number =>
  getSocietyValueAtDate(society, new Date());
